<template>
<div>
    <page :page='page' :router_name='router_name'></page>
        <div v-show="page.length == 0" style="margin:40px auto;font-size:21px;text-align: center;">
            <img src="../../assets/loading.gif">
        </div>
    <moreButton button_text="返回列表" :button_href='router_name'></moreButton>
</div>
    
</template>
<script>
import page from '@/components/list/page'
import MoreButton from '@/components/index/MoreButton'
export default {
    components: {
        'page': page,
        'moreButton': MoreButton,
    },
    data(){
        return {
            page: [],
            router_name:"../winner",
        }
    },
    computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
    }
  },
    created(){
        var newsid = this.$route.params.id;
        var pagebox = [];
        var vm = this
        var news_api = vm.API + 'api/tlweb/news?kind=3'
        // axios.get('http://localhost/api/tlweb/news?kind=3')
    vm.axios.get(news_api)
      .then(function (response) {
        pagebox = response.data.data.data.reverse()
        // console.log(newsbox.id);
        for(var search=0;search<pagebox.length;search++){
            if(newsid==pagebox[search].id){
              vm.page = pagebox[search]
            }
        }       
       
      })
      .catch(function (error) {
        console.log(error);
      });
  },
}
</script>
<style>

</style>


